<template>
  <v-container fluid pa-2 v-scroll="onScrollFunction" background class="contain_width" >
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
    <filter-component :json_data ="form_filter_data" v-on:set="onCloseFormDialog" />
    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>
    <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <v-flex sm12 xs12  class="search_in_page_flex">
            <v-text-field
              solo
              label="ค้นหา..."
              v-model="Search_data"
              @input="searchProcess()"
              append-icon="search"
              style="margin-bottom: 0px;"
            ></v-text-field>
      </v-flex>
    </v-layout> 
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex lg2 md4 sm4 xs6 v-for="(item, index) in table_data" :key="index" @click="''">
             <v-card class=" boxEmp " >
               <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-center">
              <v-menu offset-y>
                  <template  slot="activator" >
                    <v-btn icon>
                            <v-icon small>fas fa-ellipsis-v</v-icon>
                          </v-btn> 
                  </template>
                  <v-card class="pa-0" max-width="350">

                      <v-card-title class="setbox" v-if="permission_edit == true || admin == 'true'"> 
                        <v-btn slot="activator" color="warning" block  flat @click="onHandleDialog(true,'update',item)">
                            <v-icon :size = 14 style="margin-right:5px;">edit</v-icon>
                            <span>{{$t('edit')}}</span>
                        </v-btn>
                      </v-card-title>
                      <v-card-title  class="setbox" v-if="permission_edit == true || admin == 'true'">
                          <v-btn slot="activator" color="success" block flat @click="_reactive(item)">
                            <v-icon :size = 16 style="margin-right:5px;">check</v-icon>
                            <span>{{$t('Active')}}</span>
                          </v-btn>
                      </v-card-title>
                  </v-card>
              </v-menu>
              </div>
            </v-card-actions>
              <v-card-title >
                <v-layout row warp style="margin-top:-25px;">
                    <v-flex md12 sm12 xs12 text-xs-center>
                    <v-avatar class="avatar"
                    v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                    :size="64"
                    color="teal"
                  >
                    <span style="font-size:1.5em;color:#fff;"  >{{item.nick_name}}</span>
                  </v-avatar>
                   <Empimage
                    v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                    :json_data="item.emp_images"
                  />
                    </v-flex>
                </v-layout>

              </v-card-title>
              <v-card-title>
                    <v-flex md12 sm12 xs12 text-xs-center>
                   <span >{{item.first_name}} {{item.last_name}}</span>
                    </v-flex>
                      <v-flex md12 sm12 xs12 text-xs-center>
                   <span
                        v-show="isEmpty(item.nick_name) && item.nick_name != 'null'"
                        v-html="' (<span style=color:#166BFF;>'+item.nick_name+'</span>)'"
                      />
                      
                    <span 
                        v-show="item.nick_name =='' || item.nick_name == 'null'"
                        v-html="'</br>'"/>
                    </v-flex>
              </v-card-title>
        <v-divider class="mx-4" ></v-divider>
    <v-card-title>
       <v-layout row wrap>
      <v-flex lg6 md6 sm6 xs5 pa-1>
        <span >{{$t('code')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1>
        <span class="coco-list-label-text">{{item.code}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs5 pa-1>
        <span >{{$t('Position')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1>
        <span class="coco-list-label-text" >{{item.position}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs5 pa-1>
        <span >{{$t('TelephoneNumber')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1>
        <span class="coco-list-label-text">{{item.phone_num}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs5 pa-1>
        <span >{{$t('Salary')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1>
        <span class="coco-list-label-text" >{{item.current_salary}}</span>
      </v-flex>
       <v-flex lg6 md6 sm6 xs5 pa-1 v-if="item.resign_time == null">
        <span >{{$t('StartworkingDate')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1 v-if="item.resign_time == null">
        <span class="coco-list-label-text" >{{dateformat(item.start_work_date)}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs5 pa-1 v-if="item.resign_time != null">
        <span >{{$t('ResignAt')}}</span>
      </v-flex>
      <v-flex lg6 md6 sm6 xs7 pa-1 v-if="item.resign_time != null">
        <span class="coco-list-label-text" >{{dateformat(item.resign_time)}}</span>
      </v-flex>
       </v-layout>
    </v-card-title>
  </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- pagination -->
       <v-layout row wrap my-2>
      <v-flex xs12 >
        <div class="show_pagination_fixed" >
          <v-pagination fixed v-model="pageActive" :length="totalPages" :total-visible="7" circle  @input="getEmployeeInactiveList('List')"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
     <!-- reactive dialog -->
      <v-flex>
         <v-dialog v-model="reactive_dialog" max-width="300">
      <v-card>
        <v-card-title class="headline green darken-1" primary-title style="color:white">
          {{$t('reactive')}}
        </v-card-title>
        <v-card-text>
           <v-layout row wrap pa-3>
          <v-flex xs12 style="margin-top:15px;">
           {{$t('question.reactive')}} {{reactiveDetail}}
          </v-flex>
           </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="reactive_dialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="primary" text @click="sendreactive()">{{$t('submit')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      </v-flex>
      <!-- FormDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="form_dialog_data" v-on:close-dialog="onCloseFormDialog" />
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import EmployeeService from "@/services/EmployeeService";
import Empimage from "../../components/getempimage.vue";
import FrmDialog from "./FormDialog";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Utils from "@/utils/";
import $ from "jquery";
import FilterComponent from "./Filter";
import moment from "moment";
import UserService from "@/services/UserService";
export default {
  data: () => ({
    item: 1,
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
    Search_data: "",
    admin:false,
    show_search: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    form_filter_data: {
      status: false,
     
    },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    img_not_found: "@/assets/user.png",
    table_data: [],
    pageActive: 1,
    totalPages:0,
    onload: false,
    processing: false,
    canLoadMore: true,
    timeout: null,
    permission_edit:false,
    permission_view:false,
    reactive_dialog: false,
    empCode: localStorage._empcode,
    permission:[],
    reactive_usercode:"",
    reactiveDetail: "",
    reactiveDetailEmailTel : "",
    reactiveEmail: "",
    reactiveTel : "",
  }),
  created: async function() {
    this.admin = localStorage._is_admin;
    await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
    await this.checkpermission("Employeeinactive")
    
    
    // this.setShowFilter({
    //   status: 2
    // });
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.onload = true;
    this.getEmployeeInactiveList("Form");
    let v = this;
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    FrmDialog,
    DeleteDialog,
    Empimage,
    FilterComponent
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", ["showLoading"]),
    ...mapState("filter", ["loading", "Employee_List"]),
   // ...mapState("permissionmenu", ["permission_List"])
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("filter", ["setSearchData"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    ...mapActions("filter", ["getEmployee"]),
    // ...mapActions("permissionmenu", ["getPermissionEdit"]),
    // ...mapMutations("permissionmenu", ["getAllPermission"]),
    onCloseFormDialog() {
      this.form_dialog_data.status = false;
      this.onload = true;
      this.getEmployee("newData");
      this.getEmployeeInactiveList("Form");
    },
     dateformat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.getEmployeeInactiveList("Filter");
      }, 1500);
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
        $('#pagetitleshow').removeClass('showtitlepage')
      } else {
        this.show_search = true;
        $('#pagetitleshow').addClass('showtitlepage')
        //console.log($('#pagetitleshow'))
      }
    },
    showFilter(status){
      this.form_filter_data = {
        status: status,
        data:1
      };
    },
   checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    onHandleDialog(status, save_type, data) {
      this.form_dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
       //console.log("5555",this.form_dialog_data);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      ////console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      ////console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeInactiveList('List');
          //console.log('last');
        }
        if(this.processing && this.canLoadMore){
          //console.log('not last');
        }
       }*/
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    getEmployeeInactiveList(Action) {
      this.processing = true;
      this.commitSetShowLoading(true);

      //console.log("Search" + this.SearchData);

      EmployeeService.getEmployeeInactive(
        this.SelectBranch,
        this.SelectDepartment,
        this.SelectPosition,
        this.Search_data,
        this.pageActive
      )
        .then(res => {
          var user_img = "";
          if (this.table_data.length > 0 && Action == "List") {
            if (res.data.content.length > 0) {
              this.table_data= [];
              res.data.content.forEach(data => {
                this.table_data.push(data);
              });
              this.totalPages = res.data.totalPages;
              
            } else {
              this.canLoadMore = false;
            }
          } else {
            this.table_data = res.data.content;
           // console.log("fffff",res);
            this.totalPages = res.data.totalPages;
            //console.log(this.table_data);
          }
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
          this.processing = false;
        });
    },
     _reactive(data){
      console.log(data);
      let rowEdit = data
      this.reactive_usercode = rowEdit.code;
      this.reactiveDetail = rowEdit.first_name + ' ' + rowEdit.last_name;
      this.reactiveDetailEmailTel = 'Email : ' + rowEdit.email ;
      this.reactiveEmail = rowEdit.email;
      this.reactiveTel = '';
      this.reactive_dialog = true;
    },
    sendreactive() {
        EmployeeService.EmployeeReactive(this.reactive_usercode)
        .then(res => {
          this.snack_model.status = true;
          this.snack_model.msg = this.$t("message.updatestatus");
          this.snack_model.type = "success";
          this.onload = true;
          this.getEmployeeInactiveList();
          this.reactive_dialog = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
  }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

span {
  font-family: "Prompt", sans-serif;
}
.content {
  margin-top: 5px;
  margin-bottom: 5px;
}
.setbox{
padding-left: 5px !important;
padding-right: 5px !important;
padding-top: 0px !important ;
padding-bottom: 0px !important ;
text-align: left;
width: 120px;
}
.background {
  background: url("../../assets/banner1.png") no-repeat fixed top;
  }
  .boxEmp{
  width: 90% !important;
  height: 430px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  margin:10px;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  text-align: left;
 
}

@media screen and (min-width: 1366px){
.boxEmp{
  width: 90% !important;
  height: 430px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  margin:10px;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  text-align: left;
 
}
}
/* mobile  ----------- */
@media screen and  (max-width: 812px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
  .boxEmp{
  width: 95% !important;
  height: 350px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:5px;
  text-align: left;
  font-size: 0.7em;
 
}
  
}
 
.font-menu{
  font-size: 0.5rem ;
}
.icon-menu{
  font-size: 2rem ;
}
/* tablet  ----------- */
@media screen and (min-width: 768px) and (max-width: 1024px){
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
  .boxEmp{
  width: 90% !important;
  height: 400px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:10px;
  text-align: left;
   font-size: 0.9em;
   
 
}
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
   .boxEmp{
  width: 90% !important;
  height: 420px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:10px;
  text-align: left;
 font-size: 1em;
}

}

@media screen and (min-width: 1200px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
   .boxEmp{
  width: 95% !important;
  height: 400px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:5px;
  text-align: left;
  font-size: 0.9em;
 
}
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
.box-pointer {
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: 20px;
}

.box-pointer-vdo {
  cursor: pointer;
}
.avoid-clicks {
  pointer-events: none;
}
.avatar{
height: 64px !important;
width: 64px !important;
}
.showtool{
z-index: 2;
}
</style>
